import script from "./ParentsTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ParentsTable.vue?vue&type=script&lang=ts&setup=true"

import "./ParentsTable.vue?vue&type=style&index=0&id=7ad543a3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ad543a3"]])

export default __exports__